import { AfterViewInit, Component, HostListener, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { AppSettings } from '../../app.settings';
import { Settings } from '../../app.settings.model';
import { CommonService } from "../../../shared/common/common.service";
import { GlobalConfig, ToastrService } from "ngx-toastr";
import { AuthService } from '../../../auth/auth.service';

@Component({
  selector: 'app-application-container',
  templateUrl: './application-container.component.html',
  styleUrls: ['./application-container.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ApplicationContainerComponent implements OnInit, AfterViewInit {
  @Input() menuItems: Object[];
  public showMenu = false;
  public menuOption: string;
  public menuTypeOption: string;
  public showSetting = false;
  public settings: Settings;
  public loading = false;
  users;
  temp;
  options: GlobalConfig;

  constructor(
    private toastrService: ToastrService,
    private appSettings: AppSettings, 
    private commonService: CommonService,
    private authService: AuthService,
  ) {
    this.settings = this.appSettings.settings;

    if (sessionStorage["skin"]) {
      this.settings.theme.skin = sessionStorage["skin"];
    }

    this.commonService.Loader
      .subscribe((value: boolean) => {
        this.loading = value;
      })   
  }

  ngOnInit() {
    if (window.innerWidth <= 768) {
      this.settings.theme.showMenu = false;
    }

    this.menuOption = this.settings.theme.menu;
    this.menuTypeOption = this.settings.theme.menuType;    
    this.commonService.showLoader(false);
  }

  ngAfterViewInit() {
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    const showMenu = !this._showMenu();

    if (this.showMenu !== showMenu) {
      this.showMenuStateChange(showMenu);
    }
    this.showMenu = showMenu;
  }

  showMenuStateChange(showMenu: boolean): void {
    this.settings.theme.showMenu = showMenu;
  }

  private _showMenu(): boolean {
    return window.innerWidth <= 768;
  }  
}



// WEBPACK FOOTER //
// ./src/app/core/components/application-container/application-container.component.ts